import i18n from 'i18next';
import i18nBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import {
  DEFAULT_LANGUAGE,
  getStoredLanguage,
  SUPPORTED_LANGUAGES,
} from './languages';

// Cache-bust the translation files so new keys show up after a deploy.
// Set by Presentation.csproj on publish; falls back to page load time (e.g. npm start).
const buildId = process.env.REACT_APP_BUILD_ID || Date.now();

const language = getStoredLanguage();
document.documentElement.lang = language;

i18n
  .use(i18nBackend)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: `/locales/{{lng}}/{{ns}}.json?v=${buildId}`,
    },
    fallbackLng: DEFAULT_LANGUAGE,
    interpolation: {
      escapeValue: false, // react already protects from xss
    },
    lng: language,
    whitelist: SUPPORTED_LANGUAGES,
  });

export default i18n;
